import React, { useEffect, useContext, useState, useRef } from "react";

import {
    OnBoardNotClear,
    TokenVerificationLoggedin,
    ScreenView
} from "../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import FullLoader from "../assets/images/full-page-loader.gif";
// import {
//   Col,
//   Row,
//   Input,
//   Space,
//   Select,
//   Radio,
//   Switch,
//   message,
//   Upload,
// } from "antd";
import copyIcon from '../assets/images/icons/copy.svg';
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import backButton from '../assets/images/back_button_arrow.svg';
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import configData from "../config/config.json";
import { notifysuccess } from "../utils/toast";
import { notifyfailure } from "../utils/toast";
import { notifycatch } from "../utils/toast";
import { Radio, Select, Col, Row, Input, Checkbox, Tooltip, Modal } from "antd";
import homeIcon from "../assets/images/icons/home.svg";
import uploadIcon from "../assets/images/icons/upload-cloud.svg";
import zoneInfoIcon from '../assets/images/icons/zone-info.svg';
import deleteIcon from '../assets/images/icons/trash.svg';
import zoomIcon from '../assets/images/icons/expand.svg';
import playIcon from '../assets/images/icons/play.svg';
import addVideoIcon from '../assets/images/icons/addVideoicon.svg';
import zoneIcon from '../assets/images/icons/zone.svg';
import { toast } from "react-toastify";
import loaderIcon from "../assets/images/login-and-signup/loader.gif";
const { Search } = Input;

const ZoneImport = ({ handlePageViewChange }) => {
    // const loadingContext = useContext(LoadingContext);

    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    });


    useEffect(() => {
        resetFormView()

        axios
            .get(configData.SERVER_URL + `zone/pubMinifiedList?imported=true`, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setPublisherList(response.data.data);
            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "ops/getExchangeTypes", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setIntegrationTypeOptions_openrtb(response.data.data);
            })
            .catch((error) => { });
    }, []);


    ////////////////////////////////////////////role and publisher list/publisher for not admin states  and form view////////////////////////////////

    function resetFormView() {

        setSelectedPublisher("");
        setPublisherIsRequiredError(false);
        // setPublisherList([]);

        setSelectedZoneId("");
        setZoneIdIsRequiredError(false);
        setZoneIdErrorMsg(false)
        setZoneIdList([]);
        setZoneIdListLoading(false)

        setZoneData({})

        setFormType("")
        setFormTypeLoading(false)
        setButtonProcessing(false)

        reset_prebid()
        reset_openrtb()
        reset_vastzone()

    }



    const [publisherName, setPublisherName] = useState("");  //need to be removed
    const [selectedPublisher, setSelectedPublisher] = useState("");
    const [publisherIsRequiredError, setPublisherIsRequiredError] =
        useState(false);
    const [publisherErrorMsg, setPublisherErrorMsg] =
        useState("");
    const [publisherList, setPublisherList] = useState([]);


    // const [zoneId, setZoneId] = useState("");
    const [selectedZoneId, setSelectedZoneId] = useState("");
    const [zoneIdIsRequiredError, setZoneIdIsRequiredError] =
        useState(false);
    const [zoneIdErrorMsg, setZoneIdErrorMsg] =
        useState("");
    const [zoneIdList, setZoneIdList] = useState([]);
    const [zoneIdListLoading, setZoneIdListLoading] = useState(false);



    const [buttonProcessing, setButtonProcessing] = useState(false);



    function onChangePublisher(event) {

        setPublisherIsRequiredError(false);
        setPublisherErrorMsg("");
        setSelectedPublisher(event);

        setZoneIdListLoading(true)
        setZoneIdList([])
        setSelectedZoneId("")
        setZoneIdErrorMsg("")
        setZoneIdIsRequiredError(false)

        setZoneData({})
        setFormType("")
        setFormTypeLoading(false)
        reset_prebid()
        reset_vastzone()
        reset_openrtb()


        let id = event.split("-");

        axios
            .get(configData.SERVER_URL + `port/getZoneData?publisherId=` + id[0], {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setZoneIdList(response.data.data);
                setZoneIdListLoading(false)
                if (response?.data?.data?.length === 0) {
                    setPublisherErrorMsg("No zone found for the selected publisher")
                    setPublisherIsRequiredError(true)
                }
            })
            .catch((error) => {
                setZoneIdListLoading(false)

                if (error?.response) {
                    if (error?.response?.status === 404) {
                        //   notifyfailure(error.response.data.message)
                        setPublisherErrorMsg("No zone found for the selected publisher")
                    }
                } else {
                    setPublisherErrorMsg("Unable to fetch zones for the selected publisher")
                }
                setPublisherIsRequiredError(true)

            });
    }


    const [zoneData, setZoneData] = useState({});

    function onChangeZoneId(event) {
        setZoneIdIsRequiredError(false)
        setZoneIdErrorMsg("")
        setFormType("")
        setZoneData({})
        setSelectedZoneId(event)

        reset_vastzone()
        reset_prebid()
        reset_openrtb()


        setFormTypeLoading(true)

        axios
            .get(configData.SERVER_URL + `port/zoneDetailsById?zoneId=` + JSON.stringify(event), {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setZoneData(response.data.data);
                if (response?.data?.data?.z_cate === "Vast Zone") {
                    setFormType("Vast Zone")

                    if (typeof response?.data?.data === 'object') {
                        setZoneName_vastzone(response?.data?.data.z_name ? response?.data?.data.z_name : "")
                        setZoneActiveCheckbox_vastzone(response?.data?.data.status ? response?.data?.data.status : false)
                        setImpression_vastzone(response?.data?.data.imp_daily ? response?.data?.data.imp_daily : null)
                        setRequest_vastzone(response?.data?.data.req_daily ? response?.data?.data.req_daily : null)


                        if (response?.data?.data.revenue_type === "REVSHARE") {

                            setRevenueType_vastzone("Revshare")
                            setRevSharePercent_vastzone(response?.data?.data.revshare)


                        }
                        if (response?.data?.data.revenue_type === "FIXED_PRICE") {

                            setRevenueType_vastzone("Fixed_Price")
                            setECpm_vastzone(response?.data?.data.fixed_cpm)

                        }

                    }


                }

                setFormTypeLoading(false)

            })
            .catch((error) => {
                setZoneIdIsRequiredError(true)
                setZoneIdErrorMsg("Error fetching zone data")

            });
    }




    const [formType, setFormType] = useState("");
    const [formTypeLoading, setFormTypeLoading] = useState(false);
    const [formTypeOption] = useState([
        { label: "Prebid", value: "Prebid" },
        { label: "Open RTB", value: "Open RTB" },
    ]);

    function onChangeFormType(event) {

        setFormType(event);

        if (event === "Prebid") {
            reset_prebid()
            reset_openrtb()

            if (typeof zoneData === 'object') {
                setZoneName_prebid(zoneData.z_name ? zoneData.z_name : "")
                setZoneActiveCheckbox_prebid(zoneData.status ? zoneData.status : false)
                setImpression_prebid(zoneData.imp_daily ? zoneData.imp_daily : null)
                setRequest_prebid(zoneData.req_daily ? zoneData.req_daily : null)
                setIntegrationType_prebid(zoneData.exchange_type)

            }

        }


        if (event === "Open RTB") {
            reset_prebid()
            reset_openrtb()

            if (typeof zoneData === 'object') {
                setZoneName_openrtb(zoneData.z_name ? zoneData.z_name : "")
                setZoneActiveCheckbox_openrtb(zoneData.status ? zoneData.status : false)
                setImpression_openrtb(zoneData.imp_daily ? zoneData.imp_daily : null)
                setRequest_openrtb(zoneData.req_daily ? zoneData.req_daily : null)
                setIntegrationType_openrtb(zoneData.exchange_type)

            }


        }






        // if (event === "Prebid") {
        //     reset_prebid();
        //     if (publisherName !== "") {
        //         setZoneName_prebid(
        //             publisherName + "-" + platformType_prebid + "-" + formatType_prebid
        //         );
        //     }
        // } else if (event === "Open RTB") {
        //     reset_openrtb();
        //     if (publisherName !== "") {
        //         setZoneName_openrtb(
        //             publisherName + "-" + platformType_openrtb + "-" + formatType_openrtb
        //         );
        //     }
        // } else if (event === "Vast Zone") {
        //     reset_vastzone();
        //     if (publisherName !== "") {
        //         setZoneName_vastzone(publisherName + "-" + platformType_vastzone);
        //     }
        // }

        // else if (event === "Player Tag") {
        //     reset_playertag();
        // }

        // else if (event === "GAM Tag") {
        //     reset_gamtag();
        // }
    }



    /////////////////////////////////////////////////////prebaid code /////////////////////////////////////////
    const [platformType_prebid, setPlatformType_prebid] = useState("");
    const [platformTypeIsRequiredError_prebid, setPlatformTypeIsRequiredError_prebid] = useState(false);

    const [formatType_prebid, setFormatType_prebid] = useState([]);
    const [formatTypeIsRequiredError_prebid, setFormatTypeIsRequiredError_prebid] = useState(false);
    const [formatTypeOptions_prebid, setFormatTypeOptions_prebid] = useState([
        { label: "Banner", value: "Banner" },
        { label: "Video", value: "Video" },
        { label: "Native", value: "Native" },
    ]);
    const [integrationType_prebid, setIntegrationType_prebid] =
        useState("OPEN_RTB");
    const [integrationTypeOptions_prebid, setIntegrationTypeOptions_prebid] =
        useState([
            { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
            { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
            { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
        ]);
    const [bannerCheckbox_prebid, setBannerCheckbox_prebid] = useState(null);
    const [bannerCheckboxIsRequiredError_prebid, setBannerCheckboxIsRequiredError_prebid] = useState(false);

    const [zoneActiveCheckbox_prebid, setZoneActiveCheckbox_prebid] =
        useState(true);
    const [zoneName_prebid, setZoneName_prebid] = useState("");
    const [zoneNameIsRequiredError_prebid, setZoneNameIsRequiredError_prebid] =
        useState(false);
    const [request_prebid, setRequest_prebid] = useState("");
    // const [requestIsRequiredError_prebid, setRequestIsRequiredError_prebid] =
    //   useState(false);
    const [requestValueError_prebid, setRequestValueError_prebid] =
        useState(false);
    const [impression_prebid, setImpression_prebid] = useState("");
    // const [
    //   impressionIsRequiredError_prebid,
    //   setImpressionIsRequiredError_prebid,
    // ] = useState(false);
    const [impressionValueError_prebid, setImpressionValueError_prebid] =
        useState(false);

    function reset_prebid() {
        setPlatformType_prebid("");
        setPlatformTypeIsRequiredError_prebid(false)
        setFormatType_prebid([]);
        setFormatTypeIsRequiredError_prebid(false)
        setFormatTypeOptions_prebid([
            { label: "Banner", value: "Banner" },
            { label: "Video", value: "Video" },
            { label: "Native", value: "Native" },
        ]);
        setIntegrationType_prebid("OPEN_RTB");
        setIntegrationTypeOptions_prebid([
            { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
            { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
            { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
        ]);
        setBannerCheckbox_prebid(null);
        setBannerCheckboxIsRequiredError_prebid(false);

        setZoneActiveCheckbox_prebid(true);
        setZoneName_prebid("");
        setZoneNameIsRequiredError_prebid(false);
        setRequest_prebid("");
        //setRequestIsRequiredError_prebid(false);
        setRequestValueError_prebid(false);
        setImpression_prebid("");
        // setImpressionIsRequiredError_prebid(false);
        setImpressionValueError_prebid(false);
    }

    function onChangePlatformType_prebid(event) {
        setPlatformType_prebid(event.target.value);
        setPlatformTypeIsRequiredError_prebid(false)

    }

    function onChangeFormatType_prebid(event) {

        if (event?.length === 0) {
            setFormatTypeIsRequiredError_prebid(true)
        }
        else {
            setFormatTypeIsRequiredError_prebid(false)
        }


        if (!event?.includes("Banner")) {
            setBannerCheckbox_prebid(null);
            setBannerCheckboxIsRequiredError_prebid(false)
        }
        setFormatType_prebid(event);


    }

    function onChangeIntegrationType_prebid(event) {
        setIntegrationType_prebid(event);
    }

    function onChangeBannerCheckbox_prebid(event) {
        setBannerCheckboxIsRequiredError_prebid(false)
        setBannerCheckbox_prebid(event.target.value);
    }

    function onChangeZoneActiveCheckbox_prebid(event) {
        setZoneActiveCheckbox_prebid(event.target.checked);
    }

    function onChangeZoneName_prebid(event) {
        setZoneNameIsRequiredError_prebid(false);
        setZoneName_prebid(event.target.value);
    }

    function onBlurZoneName_prebid(event) {
        if (event.target.value.trim().length === 0) {
            setZoneNameIsRequiredError_prebid(true);
        }
        setZoneName_prebid(event.target.value.trim());
    }

    function onChangeRequest_prebid(event) {
        if (event.target.value.trim().length === 0) {
            setRequestValueError_prebid(false);
            setRequest_prebid(event.target.value.trim());
        } else {
            if (/^\d*$/.test(event.target.value.trim())) {
                setRequest_prebid(event.target.value.trim());
                if (Number(event.target.value.trim()) > 0) {
                    setRequestValueError_prebid(false);
                } else {
                    setRequestValueError_prebid(true);
                }
            }
        }
    }

    function onBlurRequest_prebid(event) {
        if (event.target.value.trim().length === 0) {
            setRequestValueError_prebid(false);
            // setRequestIsRequiredError_prebid(true);
        } else {
            if (Number(event.target.value.trim()) > 0) {
                setRequestValueError_prebid(false);
            } else {
                // setRequestIsRequiredError_prebid(false);
                setRequestValueError_prebid(true);
            }
        }
        setRequest_prebid(event.target.value.trim());
    }

    function onChangeImpression_prebid(event) {
        if (event.target.value.trim().length === 0) {
            setImpressionValueError_prebid(false);
            setImpression_prebid(event.target.value.trim());
        } else {
            if (/^\d*$/.test(event.target.value.trim())) {
                setImpression_prebid(event.target.value.trim());
                if (Number(event.target.value.trim()) > 0) {
                    setImpressionValueError_prebid(false);
                } else {
                    setImpressionValueError_prebid(true);
                }
            }
        }
    }

    function onBlurImpression_prebid(event) {
        if (event.target.value.trim().length === 0) {
            setImpressionValueError_prebid(false);
            // setImpressionIsRequiredError_prebid(true);
        } else {
            if (Number(event.target.value.trim()) > 0) {
                setImpressionValueError_prebid(false);
            } else {
                // setImpressionIsRequiredError_prebid(false);
                setImpressionValueError_prebid(true);
            }
        }
        setImpression_prebid(event.target.value.trim());
    }

    ///////////////////////////////////////////////////open rtb code ///////////////////////////////////////////
    const [platformType_openrtb, setPlatformType_openrtb] = useState("");
    const [platformTypeIsRequiredError_openrtb, setPlatformTypeIsRequiredError_openrtb] = useState(false);
    const [formatType_openrtb, setFormatType_openrtb] = useState([]);
    const [formatTypeIsRequiredError_openrtb, setFormatTypeIsRequiredError_openrtb] = useState(false);

    const [integrationType_openrtb, setIntegrationType_openrtb] =
        useState("OPEN_RTB");
    const [integrationTypeOptions_openrtb, setIntegrationTypeOptions_openrtb] =
        useState([
            { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
            { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
            { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
        ]);

    const [bannerCheckbox_openrtb, setBannerCheckbox_openrtb] = useState(null);
    const [bannerCheckboxIsRequiredError_openrtb, setBannerCheckboxIsRequiredError_openrtb] = useState(false);

    const [zoneActiveCheckbox_openrtb, setZoneActiveCheckbox_openrtb] =
        useState(true);
    const [zoneName_openrtb, setZoneName_openrtb] = useState("");
    const [zoneNameIsRequiredError_openrtb, setZoneNameIsRequiredError_openrtb] =
        useState(false);
    const [request_openrtb, setRequest_openrtb] = useState("");
    // const [requestIsRequiredError_openrtb, setRequestIsRequiredError_openrtb] =
    //   useState(false);
    const [requestValueError_openrtb, setRequestValueError_openrtb] =
        useState(false);
    const [impression_openrtb, setImpression_openrtb] = useState("");
    // const [
    //   impressionIsRequiredError_openrtb,
    //   setImpressionIsRequiredError_openrtb,
    // ] = useState(false);
    const [impressionValueError_openrtb, setImpressionValueError_openrtb] =
        useState(false);

    function reset_openrtb() {
        setPlatformType_openrtb("");
        setPlatformTypeIsRequiredError_openrtb(false);

        setFormatType_openrtb([]);
        setFormatTypeIsRequiredError_openrtb(false)


        setIntegrationType_openrtb("OPEN_RTB");
        // setIntegrationTypeOptions_openrtb([
        //     { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
        //     { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
        //     { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
        // ]);
        setBannerCheckbox_openrtb(null);
        setBannerCheckboxIsRequiredError_openrtb(false);
        setZoneActiveCheckbox_openrtb(true);
        setZoneName_openrtb("");
        setZoneNameIsRequiredError_openrtb(false);
        setRequest_openrtb("");
        //setRequestIsRequiredError_openrtb(false);
        setRequestValueError_openrtb(false);
        setImpression_openrtb("");
        // setImpressionIsRequiredError_openrtb(false);
        setImpressionValueError_openrtb(false);
    }

    function onChangePlatformType_openrtb(event) {

        if (event.target.value === "CTV") {
            setBannerCheckbox_openrtb(null)
            setBannerCheckboxIsRequiredError_openrtb(false)

            setFormatTypeIsRequiredError_openrtb(false)
            setFormatType_openrtb([])
        }



        setPlatformType_openrtb(event.target.value);
        setPlatformTypeIsRequiredError_openrtb(false)
    }

    function onChangeFormatType_openrtb(event) {

        if (event?.length === 0) {
            setFormatTypeIsRequiredError_openrtb(true)
        }
        else {
            setFormatTypeIsRequiredError_openrtb(false)
        }

        if (!event?.includes("Banner")) {
            setBannerCheckbox_openrtb(null);
            setBannerCheckboxIsRequiredError_openrtb(false)
        }
        setFormatType_openrtb(event);
    }

    function onChangeIntegrationType_openrtb(event) {
        setIntegrationType_openrtb(event);
    }

    function onChangeBannerCheckbox_openrtb(event) {
        setBannerCheckboxIsRequiredError_openrtb(false)
        setBannerCheckbox_openrtb(event.target.value);
    }

    function onChangeZoneActiveCheckbox_openrtb(event) {
        setZoneActiveCheckbox_openrtb(event.target.checked);
    }

    function onChangeZoneName_openrtb(event) {
        setZoneNameIsRequiredError_openrtb(false);
        setZoneName_openrtb(event.target.value);
    }

    function onBlurZoneName_openrtb(event) {
        if (event.target.value.trim().length === 0) {
            setZoneNameIsRequiredError_openrtb(true);
        }
        setZoneName_openrtb(event.target.value.trim());
    }

    function onChangeRequest_openrtb(event) {
        if (event.target.value.trim().length === 0) {
            setRequestValueError_openrtb(false);
            setRequest_openrtb(event.target.value.trim());
        } else {
            if (/^\d*$/.test(event.target.value.trim())) {
                setRequest_openrtb(event.target.value.trim());
                if (Number(event.target.value.trim()) > 0) {
                    setRequestValueError_openrtb(false);
                } else {
                    setRequestValueError_openrtb(true);
                }
            }
        }
    }

    function onBlurRequest_openrtb(event) {
        if (event.target.value.trim().length === 0) {
            setRequestValueError_openrtb(false);
            // setRequestIsRequiredError_openrtb(true);
        } else {
            if (Number(event.target.value.trim()) > 0) {
                setRequestValueError_openrtb(false);
            } else {
                // setRequestIsRequiredError_openrtb(false);
                setRequestValueError_openrtb(true);
            }
        }
        setRequest_openrtb(event.target.value.trim());
    }

    function onChangeImpression_openrtb(event) {
        if (event.target.value.trim().length === 0) {
            setImpressionValueError_openrtb(false);
            setImpression_openrtb(event.target.value.trim());
        } else {
            if (/^\d*$/.test(event.target.value.trim())) {
                setImpression_openrtb(event.target.value.trim());
                if (Number(event.target.value.trim()) > 0) {
                    setImpressionValueError_openrtb(false);
                } else {
                    setImpressionValueError_openrtb(true);
                }
            }
        }
    }

    function onBlurImpression_openrtb(event) {
        if (event.target.value.trim().length === 0) {
            setImpressionValueError_openrtb(false);
            // setImpressionIsRequiredError_openrtb(true);
        } else {
            if (Number(event.target.value.trim()) > 0) {
                setImpressionValueError_openrtb(false);
            } else {
                // setImpressionIsRequiredError_openrtb(false);
                setImpressionValueError_openrtb(true);
            }
        }
        setImpression_openrtb(event.target.value.trim());
    }

    ///////////////////////////////////////////////////vast zone code ///////////////////////////////////////////

    const [platformType_vastzone, setPlatformType_vastzone] = useState("");
    const [platformTypeIsRequiredError_vastzone, setPlatformTypeIsRequiredError_vastzone] = useState(false);


    const [streamPosition_vastzone, setStreamPosition_vastzone] = useState("");
    const [streamPositionIsRequiredError_vastzone, setStreamPositionIsRequiredError_vastzone] = useState(false);
    const [streamPositionOptions_vastzone, setStreamPositionOptions_vastzone] = useState([
        { label: "Outstream", value: "Outstream" },
        { label: "Instream", value: "Instream" },
    ]);

    const [zoneActiveCheckbox_vastzone, setZoneActiveCheckbox_vastzone] =
        useState(true);
    const [zoneName_vastzone, setZoneName_vastzone] = useState("");
    const [zoneNameIsRequiredError_vastzone, setZoneNameIsRequiredError_vastzone] =
        useState(false);


    const [revenueType_vastzone, setRevenueType_vastzone] = useState("");
    const [revenueTypeOptions_vastzone, setRevenueTypeOptions_vastzone] = useState([
        { label: "Fixed Price", value: "Fixed_Price" },
        { label: "Revshare", value: "Revshare" },
    ]);

    const [eCpm_vastzone, setECpm_vastzone] = useState("");
    const [eCpmIsRequiredError_vastzone, setECpmIsRequiredError_vastzone] = useState(false);
    const [eCpmValidError_vastzone, setECpmValidError_vastzone] = useState(false);


    const [revSharePercent_vastzone, setRevSharePercent_vastzone] = useState("");
    const [revSharePercentIsRequiredError_vastzone, setRevSharePercentIsRequiredError_vastzone] = useState(false);
    const [revSharePercentValidError_vastzone, setRevSharePercentValidError_vastzone] = useState(false);



    const [request_vastzone, setRequest_vastzone] = useState("");
    // const [requestIsRequiredError_vastzone, setRequestIsRequiredError_vastzone] =
    //   useState(false);
    const [requestValueError_vastzone, setRequestValueError_vastzone] =
        useState(false);
    const [impression_vastzone, setImpression_vastzone] = useState("");
    // const [
    //   impressionIsRequiredError_vastzone,
    //   setImpressionIsRequiredError_vastzone,
    // ] = useState(false);
    const [impressionValueError_vastzone, setImpressionValueError_vastzone] =
        useState(false);

    function reset_vastzone() {
        setPlatformType_vastzone("");
        setPlatformTypeIsRequiredError_vastzone(false)
        setStreamPosition_vastzone("");
        setStreamPositionIsRequiredError_vastzone(false)
        setStreamPositionOptions_vastzone([
            { label: "Outstream", value: "Outstream" },
            { label: "Instream", value: "Instream" },
        ]);

        setZoneActiveCheckbox_vastzone(true);
        setZoneName_vastzone("");
        setZoneNameIsRequiredError_vastzone(false);
        setRevenueType_vastzone("");
        setRevenueTypeOptions_vastzone([
            { label: "Fixed Price", value: "Fixed_Price" },
            { label: "Revshare", value: "Revshare" },
        ]);
        setECpm_vastzone("");
        setECpmIsRequiredError_vastzone(false);
        setECpmValidError_vastzone(false);
        setRevSharePercent_vastzone("");
        setRevSharePercentIsRequiredError_vastzone(false);
        setRevSharePercentValidError_vastzone(false);
        setRequest_vastzone("");
        // setRequestIsRequiredError_vastzone(false);
        setRequestValueError_vastzone(false);
        setImpression_vastzone("");
        // setImpressionIsRequiredError_vastzone(false);
        setImpressionValueError_vastzone(false);
    }

    function onChangePlatformType_vastzone(event) {

        if (event.target.value === "CTV") {
            setStreamPositionIsRequiredError_vastzone(false)
            setStreamPosition_vastzone("")
        }

        setPlatformType_vastzone(event.target.value);
        setPlatformTypeIsRequiredError_vastzone(false)

    }

    function onChangeStreamPosition_vastzone(event) {
        setStreamPosition_vastzone(event);
        setStreamPositionIsRequiredError_vastzone(false)
    }



    function onChangeZoneActiveCheckbox_vastzone(event) {
        setZoneActiveCheckbox_vastzone(event.target.checked);
    }

    function onChangeZoneName_vastzone(event) {
        setZoneNameIsRequiredError_vastzone(false);
        setZoneName_vastzone(event.target.value);
    }

    function onBlurZoneName_vastzone(event) {
        if (event.target.value.trim().length === 0) {
            setZoneNameIsRequiredError_vastzone(true);
        }
        setZoneName_vastzone(event.target.value.trim());
    }

    function onChangeRevenueType_vastzone(event) {
        setRevenueType_vastzone(event);
        setECpm_vastzone("");
        setECpmIsRequiredError_vastzone(false);
        setECpmValidError_vastzone(false);
        setRevSharePercent_vastzone("");
        setRevSharePercentIsRequiredError_vastzone(false);
        setRevSharePercentValidError_vastzone(false);
    }


    function onChangeECpm_vastzone(event) {
        setECpmIsRequiredError_vastzone(false);
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setECpm_vastzone(event.target.value.trim());
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
                setECpmValidError_vastzone(false)
            }
            else {
                setECpmValidError_vastzone(true)
            }
        }
    }

    function onBlurECpm_vastzone(event) {
        if (event.target.value.trim().length === 0) {
            setECpmValidError_vastzone(false);
            setECpmIsRequiredError_vastzone(true);
        } else {
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
                setECpmValidError_vastzone(false);
            } else {
                setECpmIsRequiredError_vastzone(false);
                setECpmValidError_vastzone(true);
            }
        }
        setECpm_vastzone(event.target.value.trim());
    }

    function onChangeRevSharePercent_vastzone(event) {
        setRevSharePercentIsRequiredError_vastzone(false);
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setRevSharePercent_vastzone(event.target.value.trim());
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) <= 80) {
                setRevSharePercentValidError_vastzone(false)
            }
            else {
                setRevSharePercentValidError_vastzone(true)
            }
        }
    }

    function onBlurRevSharePercent_vastzone(event) {
        if (event.target.value.trim().length === 0) {
            setRevSharePercentValidError_vastzone(false);
            setRevSharePercentIsRequiredError_vastzone(true);
        } else {
            if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) <= 80) {
                setRevSharePercentValidError_vastzone(false);
            } else {
                setRevSharePercentIsRequiredError_vastzone(false);
                setRevSharePercentValidError_vastzone(true);
            }
        }
        setRevSharePercent_vastzone(event.target.value.trim());
    }


    function onChangeRequest_vastzone(event) {
        if (event.target.value.trim().length === 0) {
            setRequestValueError_vastzone(false);
            setRequest_vastzone(event.target.value.trim());
        } else {
            if (/^\d*$/.test(event.target.value.trim())) {
                setRequest_vastzone(event.target.value.trim());
                if (Number(event.target.value.trim()) > 0) {
                    setRequestValueError_vastzone(false);
                } else {
                    setRequestValueError_vastzone(true);
                }
            }
        }
    }

    function onBlurRequest_vastzone(event) {
        if (event.target.value.trim().length === 0) {
            setRequestValueError_vastzone(false);
            // setRequestIsRequiredError_vastzone(true);
        } else {
            if (Number(event.target.value.trim()) > 0) {
                setRequestValueError_vastzone(false);
            } else {
                // setRequestIsRequiredError_vastzone(false);
                setRequestValueError_vastzone(true);
            }
        }
        setRequest_vastzone(event.target.value.trim());
    }

    function onChangeImpression_vastzone(event) {
        if (event.target.value.trim().length === 0) {
            setImpressionValueError_vastzone(false);
            setImpression_vastzone(event.target.value.trim());
        } else {
            if (/^\d*$/.test(event.target.value.trim())) {
                setImpression_vastzone(event.target.value.trim());
                if (Number(event.target.value.trim()) > 0) {
                    setImpressionValueError_vastzone(false);
                } else {
                    setImpressionValueError_vastzone(true);
                }
            }
        }
    }

    function onBlurImpression_vastzone(event) {
        if (event.target.value.trim().length === 0) {
            setImpressionValueError_vastzone(false);
            // setImpressionIsRequiredError_vastzone(true);
        } else {
            if (Number(event.target.value.trim()) > 0) {
                setImpressionValueError_vastzone(false);
            } else {
                // setImpressionIsRequiredError_vastzone(false);
                setImpressionValueError_vastzone(true);
            }
        }
        setImpression_vastzone(event.target.value.trim());
    }



    ///////////////////////////////////////submit //////////////////////////////////////////////////////////////////

    const handleSubmit = async (e) => {
        e.preventDefault();


        if (formType === "Prebid") {

            if (zoneName_prebid !== "" &&
                formatType_prebid?.length > 0 &&
                platformType_prebid !== ""
                &&
                !formatType_prebid?.includes("Banner") ? true : bannerCheckbox_prebid !== null
            ) {
                if (
                    platformTypeIsRequiredError_prebid === false &&
                    formatTypeIsRequiredError_prebid === false &&
                    zoneNameIsRequiredError_prebid === false &&
                    publisherIsRequiredError === false &&
                    impressionValueError_prebid === false &&
                    requestValueError_prebid === false
                ) {
                    let payload =
                        formatType_prebid?.includes("Banner")
                            ? {

                                formType: formType,
                                invent_type: platformType_prebid,
                                exchange_type: integrationType_prebid,
                                traffic_type: formatType_prebid?.join(","),
                                bannerCheckbox: bannerCheckbox_prebid,
                                name: zoneName_prebid,
                                is_active: zoneActiveCheckbox_prebid,
                                impressions_daily: impression_prebid !== "" ? Number(impression_prebid) : null,
                                requests_daily: request_prebid !== "" ? Number(request_prebid) : null,
                                publisherId: selectedPublisher,
                                oldData: JSON.stringify(zoneData)
                            }
                            : {
                                formType: formType,
                                invent_type: platformType_prebid,
                                exchange_type: integrationType_prebid,
                                traffic_type: formatType_prebid?.join(","),
                                name: zoneName_prebid,
                                is_active: zoneActiveCheckbox_prebid,
                                impressions_daily: impression_prebid !== "" ? Number(impression_prebid) : null,
                                requests_daily: request_prebid !== "" ? Number(request_prebid) : null,
                                publisherId: selectedPublisher,
                                oldData: JSON.stringify(zoneData)
                            };


                    setButtonProcessing(true)

                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {
                        // setButtonValue(true);
                        let token = Cookies.get("token_xapads_ssp");
                        let id = jwtDecode(token)._id;

                        axios
                            .post(configData.SERVER_URL + `port/portZoneData`, payload, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    "x-access-token": token,
                                },
                            })
                            .then((response) => {
                                notifysuccess(response.data.message);
                                // reset_prebid()
                                // setButtonProcessing(false)
                                // setStep(2)
                                setTimeout(() => {
                                    window.location.replace("/zoneList");
                                }, 1500);
                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                        setButtonProcessing(false)
                                    }
                                } else {
                                    notifycatch();
                                    setButtonProcessing(false)
                                }

                            });
                    }
                }
            } else {
                if (zoneName_prebid === "") {
                    setZoneNameIsRequiredError_prebid(true);
                }
                if (formatType_prebid?.includes("Banner") && bannerCheckbox_prebid === null) {
                    setBannerCheckboxIsRequiredError_prebid(true)
                }
                if (formatType_prebid?.length === 0) {
                    setFormatTypeIsRequiredError_prebid(true)
                }
                if (platformType_prebid === "") {
                    setPlatformTypeIsRequiredError_prebid(true)
                }
            }

        } else if (formType === "Open RTB") {
            {


                if (zoneName_openrtb !== "" &&
                    platformType_openrtb !== ""
                    &&
                    (platformType_openrtb === "CTV" ? true : formatType_openrtb?.length > 0) &&
                    platformType_openrtb === "CTV" ? true : !formatType_openrtb?.includes("Banner") ? true : bannerCheckbox_openrtb !== null
                ) {


                    if (
                        zoneNameIsRequiredError_openrtb === false &&
                            impressionValueError_openrtb === false &&
                            requestValueError_openrtb === false &&
                            platformTypeIsRequiredError_openrtb === false &&
                            platformType_openrtb !== "CTV" ? formatTypeIsRequiredError_openrtb === false : true
                    ) {

                        let payload =
                            formatType_openrtb?.includes("Banner")
                                ? {
                                    formType: formType,
                                    invent_type: platformType_openrtb,
                                    exchange_type: integrationType_openrtb,
                                    traffic_type: platformType_openrtb === "CTV" ? "Video" : formatType_openrtb.join(","),
                                    bannerCheckbox: bannerCheckbox_openrtb,
                                    name: zoneName_openrtb,
                                    is_active: zoneActiveCheckbox_openrtb,
                                    impressions_daily: impression_openrtb !== "" ? Number(impression_openrtb) : null,
                                    requests_daily: request_openrtb !== "" ? Number(request_openrtb) : null,
                                    publisherId: selectedPublisher,
                                    oldData: JSON.stringify(zoneData)
                                }
                                : {
                                    formType: formType,
                                    invent_type: platformType_openrtb,
                                    exchange_type: integrationType_openrtb,
                                    traffic_type: platformType_openrtb === "CTV" ? "Video" : formatType_openrtb.join(","),
                                    name: zoneName_openrtb,
                                    is_active: zoneActiveCheckbox_openrtb,
                                    impressions_daily: impression_openrtb !== "" ? Number(impression_openrtb) : null,
                                    requests_daily: request_openrtb !== "" ? Number(request_openrtb) : null,
                                    publisherId: selectedPublisher,
                                    oldData: JSON.stringify(zoneData)
                                };

                        setButtonProcessing(true)


                        let status = Cookies.get("token_xapads_ssp") ? true : false;
                        if (status) {
                            // setButtonValue(true);
                            let token = Cookies.get("token_xapads_ssp");
                            let id = jwtDecode(token)._id;

                            axios
                                .post(configData.SERVER_URL + `port/portZoneData`, payload, {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        "x-access-token": token,
                                    },
                                })
                                .then((response) => {
                                    notifysuccess(response.data.message);
                                    // setDataModal_openrtb(response.data.data)
                                    // setIsModalVisible(true)
                                    // setButtonProcessing(false)
                                    // setStep(2)
                                    setTimeout(() => {
                                        window.location.replace("/zoneList");
                                    }, 1500);
                                })
                                .catch((error) => {
                                    if (error?.response) {
                                        if (error.response.data.message?.length !== 0) {
                                            notifyfailure(error.response.data.message);
                                            setButtonProcessing(false)
                                        }
                                    } else {
                                        notifycatch();
                                        setButtonProcessing(false)
                                    }
                                    // setButtonValue(false);
                                });
                        }
                    }
                } else {

                    if (zoneName_openrtb === "") {
                        setZoneNameIsRequiredError_openrtb(true);
                    }
                    if (formatType_openrtb?.includes("Banner") && bannerCheckbox_openrtb === null && platformType_openrtb !== "CTV") {
                        setBannerCheckboxIsRequiredError_openrtb(true)
                    }
                    // if (formatType_openrtb?.length === 0) {
                    //     setFormatTypeIsRequiredError_openrtb(true);
                    // }

                    if (platformType_openrtb === "") {
                        setPlatformTypeIsRequiredError_openrtb(true);
                    }

                    if (platformType_openrtb !== "CTV" && formatType_openrtb?.length === 0) {
                        setFormatTypeIsRequiredError_openrtb(true)

                    }

                }

            }
        }
        else if (formType === "Vast Zone") {
            {
                if (zoneName_vastzone !== "" &&
                    platformType_vastzone !== "" &&
                    platformType_vastzone === "CTV" ? true : streamPosition_vastzone !== "" &&
                    (revenueType_vastzone === "Fixed_Price" ? eCpm_vastzone !== "" : true) &&
                (revenueType_vastzone === "Revshare" ? revSharePercent_vastzone !== "" : true)
                ) {

                    if (
                        zoneNameIsRequiredError_vastzone === false &&
                            platformTypeIsRequiredError_vastzone === false &&
                            platformType_vastzone !== "CTV" ? streamPositionIsRequiredError_vastzone === false : true &&

                            (revenueType_vastzone === "Fixed_Price" ? eCpmIsRequiredError_vastzone === false : true) &&
                            (revenueType_vastzone === "Fixed_Price" ? eCpmValidError_vastzone === false : true) &&
                            (revenueType_vastzone === "Revshare" ? revSharePercentIsRequiredError_vastzone === false : true) &&
                        (revenueType_vastzone === "Revshare" ? revSharePercentValidError_vastzone === false : true)
                    ) {


                        let payload =
                            revenueType_vastzone === "Fixed_Price"
                                ? {
                                    formType: formType,
                                    invent_type: platformType_vastzone,
                                    stream_position: platformType_vastzone === "CTV" ? "Instream" : streamPosition_vastzone,
                                    name: zoneName_vastzone,
                                    is_active: zoneActiveCheckbox_vastzone,
                                    revenue_type: revenueType_vastzone,
                                    fixed_cpm: Number(eCpm_vastzone),
                                    publisherId: selectedPublisher,
                                    requests_daily: request_vastzone !== "" ? Number(request_vastzone) : null,
                                    impressions_daily: impression_vastzone !== "" ? Number(impression_vastzone) : null,
                                    oldData: JSON.stringify(zoneData)

                                }
                                : {
                                    formType: formType,
                                    invent_type: platformType_vastzone,
                                    stream_position: platformType_vastzone === "CTV" ? "Instream" : streamPosition_vastzone,
                                    name: zoneName_vastzone,
                                    is_active: zoneActiveCheckbox_vastzone,
                                    revenue_type: revenueType_vastzone,
                                    revshare: Number(revSharePercent_vastzone),
                                    publisherId: selectedPublisher,
                                    requests_daily: request_vastzone !== "" ? Number(request_vastzone) : null,
                                    impressions_daily: impression_vastzone !== "" ? Number(impression_vastzone) : null,
                                    oldData: JSON.stringify(zoneData)
                                };

                        setButtonProcessing(true)


                        let status = Cookies.get("token_xapads_ssp") ? true : false;
                        if (status) {
                            // setButtonValue(true);
                            let token = Cookies.get("token_xapads_ssp");
                            let id = jwtDecode(token)._id;

                            axios
                                .post(configData.SERVER_URL + `port/portZoneData`, payload, {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        "x-access-token": token,
                                    },
                                })
                                .then((response) => {
                                    notifysuccess(response.data.message);

                                    // setDataModal_vastzone(response.data.data)
                                    // setIsModalVisible(true)
                                    // setButtonProcessing(false)
                                    // setStep(2)
                                    setTimeout(() => {
                                        window.location.replace("/zoneList");
                                    }, 1500);
                                })
                                .catch((error) => {
                                    if (error?.response) {
                                        if (error.response.data.message?.length !== 0) {
                                            notifyfailure(error.response.data.message);
                                            setButtonProcessing(false)
                                        }
                                    } else {
                                        notifycatch();
                                        setButtonProcessing(false)
                                    }
                                    // setButtonValue(false);
                                });
                        }
                    }
                } else {

                    if (zoneName_vastzone === "") {
                        setZoneNameIsRequiredError_vastzone(true);
                    }
                    if (revenueType_vastzone === "Fixed_Price" && eCpm_vastzone === "") {
                        setECpmIsRequiredError_vastzone(true);
                    }
                    if (revenueType_vastzone === "Revshare" && revSharePercent_vastzone === "") {
                        setRevSharePercentIsRequiredError_vastzone(true);
                    }
                    if (platformType_vastzone !== "CTV" && streamPosition_vastzone === "") {
                        setStreamPositionIsRequiredError_vastzone(true);
                    }
                    if (platformType_vastzone === "") {
                        setPlatformTypeIsRequiredError_vastzone(true);
                    }
                }

            }
        }

    };





    return (
        <>


            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }}>
                                <img src={zoneIcon} alt="USP" /> Zones
                            </Link>
                        </li>
                        <li className="primary">Import Zone</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }}
                        />
                        <h1 className="heading">
                            Import Zone
                        </h1>
                    </div>
                </div>
                <div className="container_box--content pt_20">
                    <div className="container_box--width">

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Publisher</label>
                                    <p className="sub_text">Choose publisher account.</p>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group mb_0">
                                                <label className="form_label">Publisher * </label>
                                                <Select
                                                    showSearch
                                                    optionFilterProp="label"
                                                    className={
                                                        publisherIsRequiredError
                                                            ? "form_select basic error"
                                                            : "form_select basic "
                                                    }
                                                    // open={true}
                                                    value={selectedPublisher}
                                                    onChange={onChangePublisher}
                                                    options={publisherList}
                                                />
                                            </div>
                                            <span className="error_content">
                                                {publisherIsRequiredError && (
                                                    <> {publisherErrorMsg}</>
                                                )}
                                            </span>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Zone ID</label>
                                    <p className='sub_text'>Enter Zone ID</p>
                                </div>
                            </Col>
                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <div className="form_content_block--group mb_0">
                                        <label className='form_label'>Zone *</label>
                                        {zoneIdListLoading ?
                                            <>
                                                {/* <Search
                                                    className="form_select basic"
                                                    style={{ height: "100%" }}
                                                    disabled
                                                    loading /> */}

                                                <div className="laoding_input_form_d2">
                                                    <div className="position-relative">
                                                        <Input className="" disabled />
                                                        <img src={FullLoader} className="loader_img_d2" alt="" />
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            <Select
                                                showSearch
                                                optionFilterProp="label"
                                                className={
                                                    zoneIdIsRequiredError
                                                        ? "form_select basic error"
                                                        : "form_select basic "
                                                }
                                                // open={true}
                                                value={selectedZoneId}
                                                onChange={onChangeZoneId}
                                                options={zoneIdList}
                                                disabled={zoneIdList.length === 0}
                                            />
                                        }
                                        <span className="error_content">
                                            {zoneIdIsRequiredError && (
                                                <> {zoneIdErrorMsg}</>
                                            )}
                                        </span>
                                    </div>

                                </div>
                            </Col>
                        </Row>

                        {selectedZoneId !== "" &&
                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Zone Type</label>
                                        <p className="sub_text">Choose your zone type.</p>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className="form_content_block--group mb_0">
                                                    <label className="form_label">Zone Type * </label>
                                                    {formTypeLoading ?
                                                        // <Search
                                                        //     className="form_select basic"
                                                        //     style={{ height: "100%" }}
                                                        //     disabled
                                                        //     loading />
                                                        <div className="laoding_input_form_d2">
                                                            <div className="position-relative">
                                                                <Input className="" disabled />
                                                                <img src={FullLoader} className="loader_img_d2" alt="" />
                                                            </div>
                                                        </div>
                                                        :
                                                        <Select
                                                            showSearch={false}
                                                            optionFilterProp="label"
                                                            className="form_select basic no_search"
                                                            // open={true}
                                                            value={formType}
                                                            onChange={onChangeFormType}
                                                            options={formTypeOption}
                                                            disabled={selectedZoneId === "" || formType === "Vast Zone"}
                                                        />
                                                    }
                                                    <span className='error_content'>
                                                        <></>
                                                    </span>

                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        }

                        {formType === "Prebid" ? (
                            <>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>General details</label>
                                            <p className="sub_text">Please enter zone details</p>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container">
                                            <Row gutter={16}>
                                                <Col span={24}>
                                                    <div className="form_content_block--group">
                                                        <label className="form_label">
                                                            Traffic Type *
                                                        </label>
                                                        <Radio.Group
                                                            onChange={onChangePlatformType_prebid}
                                                            value={platformType_prebid}
                                                            className="form_radio equal_space"
                                                        >
                                                            <Radio className="radio_btn" value="Website">
                                                                Website
                                                            </Radio>
                                                            <Radio className="radio_btn" value="Inapp">
                                                                Inapp
                                                            </Radio>
                                                        </Radio.Group>
                                                        <span className="error_content">
                                                            {platformTypeIsRequiredError_prebid && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                    <div className="form_content_block--group">
                                                        <label className="form_label">Format Type *</label>
                                                        {/* <Select
                                                            optionFilterProp="label"
                                                            className={formatTypeIsRequiredError_prebid ? "form_select basic no_search error" : "form_select basic no_search"}
                                                            value={formatType_prebid}
                                                            onChange={onChangeFormatType_prebid}
                                                            options={formatTypeOptions_prebid}
                                                        /> */}
                                                        <div className='new_cls_for_checkboxgroup_d2'>
                                                            <Checkbox.Group className="form_checkbox equal_space" value={formatType_prebid} onChange={onChangeFormatType_prebid}>
                                                                <Checkbox className="checkbox_btn" value="Banner">
                                                                    Banner
                                                                </Checkbox>
                                                                <Checkbox className="checkbox_btn" value="Video">
                                                                    Video
                                                                </Checkbox>
                                                                <Checkbox className="checkbox_btn" value="Native">
                                                                    Native
                                                                </Checkbox>
                                                            </Checkbox.Group>
                                                        </div>
                                                        <span className="error_content">
                                                            {formatTypeIsRequiredError_prebid && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                    {formatType_prebid?.includes("Banner") && (
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">
                                                                In Banner Video Allow *
                                                            </label>
                                                            <Radio.Group
                                                                onChange={onChangeBannerCheckbox_prebid}
                                                                value={bannerCheckbox_prebid}
                                                                className="form_radio equal_space"
                                                            >
                                                                <Radio className="radio_btn" value={true}>
                                                                    Yes
                                                                </Radio>
                                                                <Radio className="radio_btn" value={false}>
                                                                    No
                                                                </Radio>
                                                            </Radio.Group>

                                                            <span className="error_content">
                                                                {bannerCheckboxIsRequiredError_prebid && (
                                                                    <> This field is required</>
                                                                )}
                                                            </span>
                                                        </div>
                                                    )}
                                                    <div className="hr_custom my_24"></div>
                                                    <div className="form_content_block--group">
                                                        <label className="form_label">Zone Name *</label>
                                                        <Input
                                                            className={
                                                                zoneNameIsRequiredError_prebid
                                                                    ? "form_control basic error"
                                                                    : "form_control basic"
                                                            }
                                                            value={zoneName_prebid}
                                                            onBlur={onBlurZoneName_prebid}
                                                            onChange={onChangeZoneName_prebid}
                                                            autocomplete="off"
                                                        />
                                                        <span className="error_content">
                                                            {zoneNameIsRequiredError_prebid && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                    <div className="form_content_block--group">
                                                        <div className="primary_checkbox">
                                                            <Checkbox
                                                                id="zone_checkbox_prebid"
                                                                name="zone_checkbox_prebid"
                                                                checked={zoneActiveCheckbox_prebid}
                                                                onChange={onChangeZoneActiveCheckbox_prebid}
                                                            >
                                                                <span className="form_label">
                                                                    Is Zone Active?
                                                                </span>
                                                            </Checkbox>
                                                            <span className='error_content'>
                                                                <></>
                                                            </span>

                                                        </div>
                                                    </div>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className="form_label">
                                                            Integration Type *
                                                        </label>
                                                        <Select
                                                            optionFilterProp="label"
                                                            className="form_select basic no_search"
                                                            disabled
                                                            value={integrationType_prebid}
                                                            onChange={onChangeIntegrationType_prebid}
                                                            options={integrationTypeOptions_prebid}
                                                        />
                                                        <span className='error_content'>
                                                            <></>
                                                        </span>

                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>

                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Limits</label>
                                            <p className="sub_text">Enter your zone limits</p>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container mb_0">
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className="form_label">
                                                            Requests per Day
                                                        </label>
                                                        <Input
                                                            className={
                                                                requestValueError_prebid
                                                                    ? "form_control basic error"
                                                                    : "form_control basic"
                                                            }
                                                            value={request_prebid}
                                                            onBlur={onBlurRequest_prebid}
                                                            onChange={onChangeRequest_prebid}
                                                            autocomplete="off"
                                                        />
                                                    </div>
                                                    <span className="error_content">
                                                        {/* {requestIsRequiredError_prebid && (
              <> This field is required</>
            )} */}
                                                        {requestValueError_prebid && (
                                                            <> Value should be greater than 0</>
                                                        )}
                                                    </span>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className="form_label">
                                                            Impressions per Day
                                                        </label>
                                                        <Input
                                                            className={
                                                                impressionValueError_prebid
                                                                    ? "form_control basic error"
                                                                    : "form_control basic"
                                                            }
                                                            value={impression_prebid}
                                                            onBlur={onBlurImpression_prebid}
                                                            onChange={onChangeImpression_prebid}
                                                            autocomplete="off"
                                                        />
                                                        <span className="error_content">
                                                            {/* {impressionIsRequiredError_prebid && (
              <> This field is required</>
            )} */}
                                                            {impressionValueError_prebid && (
                                                                <> Value should be greater than 0</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>

                            </>
                        ) : formType === "Open RTB" ? (
                            <>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>General details</label>
                                            <p className="sub_text">Please enter zone details</p>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container">
                                            <Row gutter={16}>
                                                <Col span={24}>
                                                    <div className="form_content_block--group">
                                                        <label className="form_label">
                                                            Traffic Type *
                                                        </label>
                                                        <Radio.Group
                                                            onChange={onChangePlatformType_openrtb}
                                                            value={platformType_openrtb}
                                                            className="form_radio equal_space"
                                                        >
                                                            <Radio className="radio_btn" value="Website">
                                                                Website
                                                            </Radio>
                                                            <Radio className="radio_btn" value="Inapp">
                                                                Inapp
                                                            </Radio>
                                                            <Radio className="radio_btn" value="CTV">
                                                                CTV
                                                            </Radio>
                                                        </Radio.Group>
                                                        <span className="error_content">
                                                            {platformTypeIsRequiredError_openrtb && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                    <div className="form_content_block--group">
                                                        <label className="form_label">Format Type *</label>
                                                        {platformType_openrtb === "CTV" ?
                                                            <div className='new_cls_for_checkboxgroup_d2'>
                                                                <Checkbox.Group className="form_checkbox equal_space" value={["Video"]} disabled>
                                                                    <Checkbox className="checkbox_btn" value="Banner">
                                                                        Banner
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn" value="Video">
                                                                        Video
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn" value="Native">
                                                                        Native
                                                                    </Checkbox>
                                                                </Checkbox.Group>
                                                            </div>
                                                            :
                                                            <>

                                                                <div className='new_cls_for_checkboxgroup_d2'>
                                                                    <Checkbox.Group className="form_checkbox equal_space" value={formatType_openrtb} onChange={onChangeFormatType_openrtb}>
                                                                        <Checkbox className="checkbox_btn" value="Banner">
                                                                            Banner
                                                                        </Checkbox>
                                                                        <Checkbox className="checkbox_btn" value="Video">
                                                                            Video
                                                                        </Checkbox>
                                                                        <Checkbox className="checkbox_btn" value="Native">
                                                                            Native
                                                                        </Checkbox>
                                                                    </Checkbox.Group>
                                                                </div>
                                                                <span className="error_content">
                                                                    {formatTypeIsRequiredError_openrtb && <> Minimum 1 selection is required</>}
                                                                </span>
                                                            </>
                                                        }

                                                    </div>
                                                    {formatType_openrtb?.includes("Banner") && platformType_openrtb !== "CTV" && (
                                                        <div className="form_content_block--group">
                                                            <label className="form_label">
                                                                In Banner Video Allow *
                                                            </label>
                                                            <Radio.Group
                                                                onChange={onChangeBannerCheckbox_openrtb}
                                                                value={bannerCheckbox_openrtb}
                                                                className="form_radio equal_space"
                                                            >
                                                                <Radio className="radio_btn" value={true}>
                                                                    Yes
                                                                </Radio>
                                                                <Radio className="radio_btn" value={false}>
                                                                    No
                                                                </Radio>
                                                            </Radio.Group>

                                                            <span className="error_content">
                                                                {bannerCheckboxIsRequiredError_openrtb && (
                                                                    <> This field is required</>
                                                                )}
                                                            </span>
                                                        </div>
                                                    )}
                                                    <div className="hr_custom "></div>
                                                    <div className="form_content_block--group">
                                                        <label className="form_label">Zone Name *</label>
                                                        <Input
                                                            className={
                                                                zoneNameIsRequiredError_openrtb
                                                                    ? "form_control basic error"
                                                                    : "form_control basic"
                                                            }
                                                            value={zoneName_openrtb}
                                                            onBlur={onBlurZoneName_openrtb}
                                                            onChange={onChangeZoneName_openrtb}
                                                            autocomplete="off"
                                                        />
                                                        <span className="error_content">
                                                            {zoneNameIsRequiredError_openrtb && (
                                                                <> This field is required</>
                                                            )}
                                                        </span>
                                                    </div>
                                                    <div className="form_content_block--group">
                                                        <div className="primary_checkbox">
                                                            <Checkbox
                                                                id="zone_checkbox_openrtb"
                                                                name="zone_checkbox_openrtb"
                                                                checked={zoneActiveCheckbox_openrtb}
                                                                onChange={onChangeZoneActiveCheckbox_openrtb}
                                                            >
                                                                <span className="form_label">
                                                                    Is Zone Active?
                                                                </span>
                                                            </Checkbox>
                                                            <span className='error_content'>
                                                                <></>
                                                            </span>

                                                        </div>
                                                    </div>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className="form_label">
                                                            Integration Type *
                                                        </label>
                                                        <Select
                                                            optionFilterProp="label"
                                                            className="form_select basic no_search"
                                                            value={integrationType_openrtb}
                                                            disabled
                                                            onChange={onChangeIntegrationType_openrtb}
                                                            options={integrationTypeOptions_openrtb}
                                                        />
                                                        <span className='error_content'>
                                                            <></>
                                                        </span>

                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>

                                <Row gutter={16}>
                                    <Col span={8}>
                                        <div className="container_box--label-info">
                                            <label>Limits</label>
                                            <p className="sub_text">Enter your zone limits</p>
                                        </div>
                                    </Col>

                                    <Col span={16}>
                                        <div className="container_box--form-container mb_0">
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className="form_label">
                                                            Requests per Day
                                                        </label>
                                                        <Input
                                                            className={
                                                                requestValueError_openrtb
                                                                    ? "form_control basic error"
                                                                    : "form_control basic"
                                                            }
                                                            value={request_openrtb}
                                                            onBlur={onBlurRequest_openrtb}
                                                            onChange={onChangeRequest_openrtb}
                                                            autocomplete="off"
                                                        />
                                                    </div>
                                                    <span className="error_content">
                                                        {/* {requestIsRequiredError_openrtb && (
              <> This field is required</>
              )} */}
                                                        {requestValueError_openrtb && (
                                                            <> Value should be greater than 0</>
                                                        )}
                                                    </span>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group mb_0">
                                                        <label className="form_label">
                                                            Impressions per Day
                                                        </label>
                                                        <Input
                                                            className={
                                                                impressionValueError_openrtb
                                                                    ? "form_control basic error"
                                                                    : "form_control basic"
                                                            }
                                                            value={impression_openrtb}
                                                            onBlur={onBlurImpression_openrtb}
                                                            onChange={onChangeImpression_openrtb}
                                                            autocomplete="off"
                                                        />
                                                        <span className="error_content">
                                                            {/* {impressionIsRequiredError_openrtb && (
              <> This field is required</>
              )} */}
                                                            {impressionValueError_openrtb && (
                                                                <> Value should be greater than 0</>
                                                            )}
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>

                            </>
                        ) :
                            formType === "Vast Zone" ?
                                (
                                    <>
                                        <Row gutter={16}>
                                            <Col span={8}>
                                                <div className="container_box--label-info">
                                                    <label>General details</label>
                                                    <p className="sub_text">Please enter zone details</p>
                                                </div>
                                            </Col>

                                            <Col span={16}>
                                                <div className="container_box--form-container">
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <div className="form_content_block--group">
                                                                <label className="form_label">
                                                                    Traffic Type *
                                                                </label>
                                                                <Radio.Group
                                                                    onChange={onChangePlatformType_vastzone}
                                                                    value={platformType_vastzone}
                                                                    className="form_radio equal_space"
                                                                >
                                                                    <Radio className="radio_btn" value="Website">
                                                                        Website
                                                                    </Radio>
                                                                    <Radio className="radio_btn" value="Inapp">
                                                                        Inapp
                                                                    </Radio>
                                                                    <Radio className="radio_btn" value="CTV">
                                                                        CTV
                                                                    </Radio>
                                                                </Radio.Group>
                                                                <span className="error_content">
                                                                    {platformTypeIsRequiredError_vastzone && (
                                                                        <> This field is required</>
                                                                    )}
                                                                </span>
                                                            </div>
                                                            <div className="form_content_block--group">
                                                                <label className="form_label">Stream Position *</label>
                                                                {platformType_vastzone === "CTV" ?
                                                                    <Input
                                                                        className="form_control basic"
                                                                        value="Instream"
                                                                        autocomplete="off"
                                                                        disabled
                                                                    />
                                                                    :
                                                                    <Select
                                                                        optionFilterProp="label"
                                                                        className={streamPositionIsRequiredError_vastzone ? "form_select basic no_search error" : "form_select basic no_search"}
                                                                        value={streamPosition_vastzone}
                                                                        onChange={onChangeStreamPosition_vastzone}
                                                                        options={streamPositionOptions_vastzone}
                                                                    />
                                                                }
                                                                <span className="error_content">
                                                                    {streamPositionIsRequiredError_vastzone && (
                                                                        <> This field is required</>
                                                                    )}
                                                                </span>
                                                            </div>


                                                            <div className="form_content_block--group">
                                                                <label className="form_label">Zone Name *</label>
                                                                <Input
                                                                    className={
                                                                        zoneNameIsRequiredError_vastzone
                                                                            ? "form_control basic error"
                                                                            : "form_control basic"
                                                                    }
                                                                    value={zoneName_vastzone}
                                                                    onBlur={onBlurZoneName_vastzone}
                                                                    onChange={onChangeZoneName_vastzone}
                                                                    autocomplete="off"
                                                                />
                                                                <span className="error_content">
                                                                    {zoneNameIsRequiredError_vastzone && (
                                                                        <> This field is required</>
                                                                    )}
                                                                </span>
                                                            </div>
                                                            <div className="form_content_block--group">
                                                                <div className="primary_checkbox">
                                                                    <Checkbox
                                                                        id="zone_checkbox_vastzone"
                                                                        name="zone_checkbox_vastzone"
                                                                        checked={zoneActiveCheckbox_vastzone}
                                                                        onChange={onChangeZoneActiveCheckbox_vastzone}
                                                                    >
                                                                        <span className="form_label">
                                                                            Is Zone Active?
                                                                        </span>
                                                                    </Checkbox>
                                                                    <span className='error_content'>
                                                                        <></>
                                                                    </span>

                                                                </div>
                                                            </div>
                                                            <Row gutter={16}>
                                                                <Col span={12}>
                                                                    <div className="form_content_block--group mb_0">
                                                                        <label className='form_label'>Revenue Type *</label>
                                                                        <Select
                                                                            showSearch={false}
                                                                            optionFilterProp="label"
                                                                            className='form_select basic no_search'
                                                                            value={revenueType_vastzone}
                                                                            onChange={onChangeRevenueType_vastzone}
                                                                            options={revenueTypeOptions_vastzone}
                                                                        />


                                                                    </div>
                                                                </Col>
                                                                {revenueType_vastzone === "Fixed_Price" ?
                                                                    <Col span={12}>
                                                                        <div className="form_content_block--group mb_0">
                                                                            <label className='form_label'>&nbsp;</label>
                                                                            <Input
                                                                                placeholder='Enter eCpm'
                                                                                className={
                                                                                    eCpmIsRequiredError_vastzone
                                                                                        ? "form_control basic error"
                                                                                        : "form_control basic"
                                                                                }
                                                                                value={eCpm_vastzone}
                                                                                onBlur={onBlurECpm_vastzone}
                                                                                onChange={onChangeECpm_vastzone}
                                                                                autocomplete="off"
                                                                            />
                                                                            <span className="error_content">
                                                                                {eCpmIsRequiredError_vastzone && (
                                                                                    <> This field is required</>
                                                                                )}
                                                                                {eCpmValidError_vastzone && (
                                                                                    <> Value should be greater than 0 and less than 100</>
                                                                                )}
                                                                            </span>
                                                                        </div>
                                                                    </Col>
                                                                    :
                                                                    <Col span={12}>
                                                                        <div className="form_content_block--group">
                                                                            <label className='form_label'>&nbsp;</label>
                                                                            <Input

                                                                                placeholder='Enter Revshare'
                                                                                className={
                                                                                    revSharePercentIsRequiredError_vastzone
                                                                                        ? "form_control basic error form_control_with_icon_d2"
                                                                                        : "form_control basic form_control_with_icon_d2"
                                                                                }
                                                                                value={revSharePercent_vastzone}
                                                                                onBlur={onBlurRevSharePercent_vastzone}
                                                                                onChange={onChangeRevSharePercent_vastzone}
                                                                                autocomplete="off"
                                                                                suffix={'%'}
                                                                            />
                                                                        </div>
                                                                        <span className="error_content">
                                                                            {revSharePercentIsRequiredError_vastzone && (
                                                                                <> This field is required</>
                                                                            )}
                                                                            {revSharePercentValidError_vastzone && (
                                                                                <> Value should be greater than 0 and less or equal to  80</>
                                                                            )}
                                                                        </span>
                                                                    </Col>
                                                                }

                                                            </Row>

                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row gutter={16}>
                                            <Col span={8}>
                                                <div className="container_box--label-info">
                                                    <label>Limits</label>
                                                    <p className="sub_text">Enter your zone limits</p>
                                                </div>
                                            </Col>

                                            <Col span={16}>
                                                <div className="container_box--form-container mb_0">
                                                    <Row gutter={16}>
                                                        <Col span={12}>
                                                            <div className="form_content_block--group mb_0">
                                                                <label className="form_label">
                                                                    Requests per Day
                                                                </label>
                                                                <Input
                                                                    className={
                                                                        requestValueError_vastzone
                                                                            ? "form_control basic error"
                                                                            : "form_control basic"
                                                                    }
                                                                    value={request_vastzone}
                                                                    onBlur={onBlurRequest_vastzone}
                                                                    onChange={onChangeRequest_vastzone}
                                                                    autocomplete="off"
                                                                />
                                                            </div>
                                                            <span className="error_content">
                                                                {/* {requestIsRequiredError_vastzone && (
              <> This field is required</>
              )} */}
                                                                {requestValueError_vastzone && (
                                                                    <> Value should be greater than 0</>
                                                                )}
                                                            </span>
                                                        </Col>
                                                        <Col span={12}>
                                                            <div className="form_content_block--group mb_0">
                                                                <label className="form_label">
                                                                    Impressions per Day
                                                                </label>
                                                                <Input
                                                                    className={
                                                                        impressionValueError_vastzone
                                                                            ? "form_control basic error"
                                                                            : "form_control basic"
                                                                    }
                                                                    value={impression_vastzone}
                                                                    onBlur={onBlurImpression_vastzone}
                                                                    onChange={onChangeImpression_vastzone}
                                                                    autocomplete="off"
                                                                />
                                                                <span className="error_content">
                                                                    {/* {impressionIsRequiredError_vastzone && (
              <> This field is required</>
              )} */}
                                                                    {impressionValueError_vastzone && (
                                                                        <> Value should be greater than 0</>
                                                                    )}
                                                                </span>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>

                                    </>
                                )
                                :
                                <></>

                        }

                    </div>
                    <div className="hr_custom mb_20"></div>
                    <div className="btn_group justify-content-end gap_8 pb_50">
                        {buttonProcessing ?
                            <>
                                <button className="w_120_d2 btn btn_white_outline w_fit_content" disabled>
                                    Discard
                                </button>
                                <button
                                    className="w_120_d2 btn btn_primary w_fit_content loader"

                                >
                                    <span>Create Zone</span>

                                    <img
                                        src={loaderIcon}
                                        alt="USP"
                                        className="loader_icon"
                                    />
                                </button>
                            </> :
                            <>
                                <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                    onClick={() => {
                                        handlePageViewChange("table")
                                        resetFormView()
                                    }}
                                >
                                    Discard
                                </button>
                                <button
                                    className="w_120_d2 btn btn_primary w_fit_content"
                                    onClick={handleSubmit}
                                    disabled={formType === ""}
                                >
                                    Create zone
                                </button>
                            </>
                        }

                    </div>


                </div>
            </div>

        </>
    );
};

export default ZoneImport;
